import React, { useEffect, useState } from 'react';
import { Translate, Terms, PersonalDataPolicy, PersonalData } from 'components';

import './style.scss';

function TermsAndCondition() {
  /* eslint-disable-next-line no-unused-vars */
  const [activeTab, setActiveTab] = useState('Terms');
  useEffect(() => {
    document.title = `Behandling av personuppgifter - TFV Tolkportal`;
  }, []);
  return (
    <div className="tv-terms-and-condition__container">
      <div className="tv-terms-and-condition__title">
        {Translate({ content: 'settings.generalTermAndCondions' })}
      </div>
      <div className="tv-terms-and-condition__tab">
        <PersonalData />
        {/* <TabButtonRow
          tabs={[
            { name: 'Terms', label: 'Användarvillkor' },
            { name: 'PersonalDataPolicy', label: 'Personuppgiftspolicy' },
          ]}
          activeTab={activeTab}
          onTabClick={tab => {
            setActiveTab(tab.name);
          }}
        /> */}
      </div>
      {activeTab === 'Terms' && <Terms />}
      {activeTab !== 'Terms' && <PersonalDataPolicy />}
    </div>
  );
}

export default TermsAndCondition;
